/**
 * Centralized API configuration for LEE
 * Automatically handles both development and production environments
 */

// Use empty string for relative URLs when REACT_APP_BACKEND_URL is not set
// This allows the app to work with the same domain proxy setup
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// API base path - uses relative path when BACKEND_URL is empty
export const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

// Helper function to build API URLs
export const apiUrl = (path) => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  return `${API_BASE}/${cleanPath}`;
};

// Export for backward compatibility
export const API = API_BASE;

export default {
  BACKEND_URL,
  API_BASE,
  API,
  apiUrl
};
